<template>
	<div class="panel_settlement">
		<div style="padding-top:7px;">
			<span class="priceItem">
				<span class="label">总计：</span>
				<span class="price">￥{{money}}</span>
			</span>
			<span class="priceItem">
				<span class="label">优惠金额：</span>
				<span class="price">￥{{$public.jian(money,activityMoney)}}</span>
			</span>
			<span class="priceItem" style="font-size: 12px;" v-if="curDiscountCard&&curDiscountCard._id">
				{{curDiscountCard.coupon_name}}({{$public.getDiscountType(curDiscountCard.apply_range.order_type)}}券)
				<span v-if="curDiscountCard.activity_type===1">
					满{{curDiscountCard.money_top}}元可用
				</span>
				<span v-if="curDiscountCard.activity_type===2">
					满{{curDiscountCard.rebate_top}}元可用，
					<span v-if="curDiscountCard.rebate_limit>0">最高抵扣{{curDiscountCard.rebate_limit}}元</span>
					<span v-else></span>
				</span>
				<span style="color:#1890FF;cursor: pointer;" @click="delDiscountCard">删除</span>
			</span>
		</div>
		<div>
			<span class="priceItem" style="margin-right: 20px;">
				<span class="label">应付金额：</span>
				<span class="price" style="color:#FF2F2F;">￥{{activityMoney}}</span>
			</span>
			<el-button style="width:80px;" type="warning" size="small" plain @click="openDiscountCard" v-if="$public.isNull(this.curDiscountCard)">优惠券</el-button>
			<el-button style="width:80px;" type="warning" size="small" plain @click="openBeizhu">备注</el-button>
			<el-button style="width:100px;" type="warning" size="small" plain @click="submitOrder">生成订单</el-button>
			<el-button style="width:80px;" type="warning" size="small" @click="submitOrderAndSettlement">结算</el-button>
		</div>
		<!-- 备注弹窗 -->
		<div v-if="drawerRemark_state">
			<drawerRemark :type="'xizaoka'" @submit="submit_drawerRemark"></drawerRemark>
		</div>
		<!-- 结算 -->
		<div v-if="dialogSettlement_state">
			<dialogSettlement :type="'order'" :orderId="curOrder._id" @submit="submit_dialogSettlement"></dialogSettlement>
		</div>
		<!-- 优惠券 -->
		<div v-show="drawerDiscountCard_state">
			<!-- <drawerDiscountCard :state="drawerDiscountCard_state" :type="'洗澡卡'" @submit="submit_drawerDiscountCard"></drawerDiscountCard> -->
			<drawerDiscountCard :userId="userInfo._id" :state="drawerDiscountCard_state" :type="9" :money="money" @submit="submit_drawerDiscountCard"></drawerDiscountCard>
		</div>
	</div>
</template>
<script>
	import drawerDiscountCard from "../drawer/discountCard.vue"
	import drawerRemark from "../drawer/remark.vue"
	import dialogSettlement from "../../../../components/dialog_settlement.vue"
	export default {
		components:{drawerDiscountCard,drawerRemark,dialogSettlement},
		data(){
			return{
				// 备注
				drawerRemark_state:false,
				// 结算
				dialogSettlement_state:false,
				curOrder:{},
				// 
				o:null,
				serviceList:[],
				// 优惠券
				drawerDiscountCard_state:false,
				// 是否直接结算
				direct:false,
			}
		},
		computed:{
			userInfo(){
				if(this.$store.state.mendian.userInfo._id){
					return this.$store.state.mendian.userInfo;
				}else{
					return {
						basic_info:{},
						card_info:{},
						company_info:{},
						operation_info:{},
						pets_info:[],
						club_card:{}
					}
				}
			},
			curPetId(){
				return this.$store.state.mendian.curPetId;
			},
			curPetInfo(){
				return this.$store.getters['mendian/curPetInfo'];
			},
			curDiscountCard(){
				return this.$store.state.xizaoka.curDiscountCard;
			},
			addParams(){
				return this.$store.state.xizaoka.addParams;
			},
			money(){
				return this.$store.state.xizaoka.money;
			},
			activityMoney(){
				return this.$store.state.xizaoka.activityMoney;
			},
			remark(){
				return this.$store.state.xizaoka.remark;
			},
			cardCount(){
				return this.$store.state.mendian.cardCount;
			},
		},
		mounted(){
		},
		methods:{
			submitOrderAndSettlement(){
				this.direct = true;
				this.submitOrder();
			},
			// 创建订单
			submitOrder(){
				if(!this.addParams.goodsId){
					this.$message({
						message: '请选择洗美卡',
						type: 'error'
					});
					return ;
				}
				if(this.$public.isNull(this.addParams.saleManIdList)){
					this.$message({
						message: '请选择销售人员',
						type: 'error'
					});
					return ;
				}
				// let arrList = ['62f616b1c93f541cc51d4879','62f616f5c93f541cc51d48cf']
				// if(arrList.indexOf(this.addParams.serviceId)>-1){
				// 	if(!this.$public.isNull(this.addParams.saleManIdList)){
				// 		setTimeout(()=>{
				// 			this.$message({
				// 				message: '售卖该洗澡卡不参与提成，已删除本单的销售人员',
				// 				type:'warning'
				// 			});
				// 		},1500)
				// 	}
				// 	this.addParams.saleManIdList = []
				// }else{
				// 	if(this.$public.isNull(this.addParams.saleManIdList)){
				// 		this.$message({
				// 			message: '请选择销售人员',
				// 			type: 'error'
				// 		});
				// 		return ;
				// 	}
				// }
				let salesMans = []
				for(let i=0;i<this.addParams.saleManIdList.length;i++){
					let arr = this.addParams.saleManIdList[i].split(',')
					salesMans.push({"userId": arr[0],"userName": arr[1]})
				}
				// if(salesMans.length===0){
				// 	salesMans.push({"userId": '',"userName": ''})
				// }
				let arr = []
				for(let i=0;this.addParams.giftTableData&&i<this.addParams.giftTableData.length;i++){
					let goods = this.addParams.giftTableData[i];
					console.log(goods.num)
					if(goods.num===0) continue;
					let one = {
						"goodsId": goods.goodsId,
						"goodsName": goods.goodsName,  
						"goodsType": goods.goodsType,
						"brand": "",
						"categoryId": "",
						"categoryName": "",
						"petId": '',
						"petName": '',  
						"skus": goods.skus,
						"skuValue": goods.skuValue,
						"unitId":  goods.unitId,
						"unit":  goods.unit,
						"originalPrice": goods.originalPrice,
						"price": goods.price,
						"num": goods.num,
						"activityId": '',
						"activityName":'',
						goodsList:[],
						"salesMans": salesMans,
						"goodsSalesModel": 2,          // 商品销售模式  0老数据 1：正常销售；2：赠品
					}
					for(let a=0;a<goods.goodsList.length;a++){
						one.goodsList.push(
							{
								"goodsId": goods.goodsList[a].goodsId,         
								"goodsName": goods.goodsList[a].goodsName,       
								"customBarCode": goods.goodsList[a].customCode, // 条码
								"price": goods.goodsList[a].price,
								"costPrice":goods.goodsList[a].costPrice,
								"skus": goods.goodsList[a].skus,
								"skuValue": goods.goodsList[a].skuValue,
								"model": goods.goodsList[a].skuValue,       
								"unitId": goods.goodsList[a].unitId,
								"unit": goods.goodsList[a].unit,
								"expiryDate": goods.goodsList[a].validityStopDate,    
								"isOut": false,
								"outDosage": 0,
								"outUnit": "",
								"goodsSalesModel": 2,          // 商品销售模式  0老数据 1：正常销售；2：赠品
							}
						);
					}
					arr.push(one)
				}
				let one = {
					"goodsId": this.addParams.serviceId,          // 销售对象id
					"goodsName": this.addParams.serviceItem.serviceName,        // 销售对象名字
					"goodsType": 6,               // 0.商品 1. 药品 2.生活服务 3.优惠券 4.医疗服务 5.活体 6.洗美卡
					"brand": "",
					"categoryId": this.addParams.serviceItem.category_info._id,
					"categoryName": this.addParams.serviceItem.category_info.name,
					"petId": '',
					"petName": '',  
					"skus": this.addParams.goodsId,
					"skuValue": this.addParams.goodsItem.goodsName,
					"unitId": '',
					"unit": '',
					"originalPrice": this.money,
					"price": this.activityMoney,
					"num": 1,
					"activityId": this.addParams.activityId||'',
					"activityName":this.addParams.activityId?this.addParams.activityItem.name:'',
					"payType":this.addParams.activityId?this.addParams.activityItem.pay_type:'',
					"salesMans": salesMans,
					"goodsList":[],
					"goodsSalesModel": 1,          // 商品销售模式  0老数据 1：正常销售；2：赠品
				}
				one.goodsList.push(
					{
						"goodsId": this.addParams.serviceId,          // 销售对象id
						"goodsName": this.addParams.serviceItem.serviceName,        // 销售对象名字  
						"customBarCode": '', // 条码
						"price": this.activityMoney,
						"costPrice":0,
						"skus": this.addParams.goodsId,
						"skuValue": this.addParams.goodsItem.goodsName,
						"model": this.addParams.goodsItem.goodsName,       
						"unitId": '',
						"unit": '',
						"expiryDate": '',    
						"isOut": false,
						"outDosage": 0,
						"outUnit": "",
						"goodsSalesModel": 1,          // 商品销售模式  0老数据 1：正常销售；2：赠品
					}
				);
				let params = {
					"memberId": this.userInfo._id,
					"memberName": this.userInfo.basic_info.nick_name,
					"memberMobile":this.userInfo.basic_info.user_mobile,
					"remark": this.remark,      // 订单备注
					coupon_no:this.curDiscountCard?this.curDiscountCard._no:'',
					"orderGoods": [one].concat(arr)
				}
				console.log(params)
				let loading = this.$loading()
				this.$http.post('/api/Order/CreateVirtualOrder', params).then(res => {
					loading.close();
					if (res.code == 0) {
						if(this.direct){
							this.curOrder = res.data;
							this.dialogSettlement_state = true;
						}else{
							this.$message({
								message: '操作成功',
								type:'success'
							});
							this.$store.commit('xizaoka/set_type','list')
						}
						
					}
				})
			},
			// 优惠券
			openDiscountCard(){
				if (this.$public.isNull(this.addParams.activityId)) {
					this.drawerDiscountCard_state = true;
				} else {
					this.$message({
						message: '参与活动后不可使用优惠券',
						type: 'error'
					});
				}
			},
			submit_drawerDiscountCard(obj){
				if(obj.type==="submit"){
					this.$store.commit('xizaoka/set_activityMoney',obj.newMoney)
					this.$store.commit('xizaoka/set_curDiscountCard',obj.card)
					this.drawerDiscountCard_state = false;
				}else{
					this.drawerDiscountCard_state = false;
				}
			},
			delDiscountCard(){
				this.$confirm('确定要删除?', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				}).then(() => {
					this.$store.commit('xizaoka/set_activityMoney',this.money)
					this.$store.commit("xizaoka/set_curDiscountCard",null)
				})
			},
			// 结算
			submit_dialogSettlement(a){
				this.dialogSettlement_state = false;
				if(a=='cancel'){
					console.log(a)
				}else if(a=='fail'){
					this.$message({
						message: '结算失败',
						type: 'error'
					});
				}else if(a=='success'){
					this.$message({
						message: '结算成功',
						type: 'success'
					});
					this.$store.dispatch("mendian/getUserInfo",this.userInfo._id)
					this.$store.commit('mendian/set_cardCount',{card_count:this.cardCount.card_count+1, coupon_count:this.cardCount.coupon_count})
				}
				this.$store.commit('xizaoka/set_type','list')
			},
			// 备注
			openBeizhu(){
				this.drawerRemark_state=true;
			},
			submit_drawerRemark(){
				this.drawerRemark_state=false;
			},
		}
	}
</script>
<style scoped lang="scss">
.panel_settlement{
	display: flex;
	justify-content: space-between;
	padding:10px 20px;
	background-color: #fff;
	box-shadow: 0 -3px 3px 0px #f5f5f5;
	.priceItem{
		display: inline-flex;align-items: center;
		margin-right: 40px;
		.label{
			font-size: 14px;color:$fontColor;
		}
		.price{
			font-size: 20px;color:$fontColor;
		}
	}
}
</style>
